var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.flag || _vm.fromProps && _vm.show,
      expression: "flag || (fromProps && show)"
    }],
    class: {
      loadingMask: true,
      part: !_vm.showMask
    }
  }, [_c('svg', {
    staticClass: "sp-icon is-spinner",
    style: {
      stroke: _vm.color,
      height: '40px',
      width: '40px',
      strokeWidth: '2px'
    },
    attrs: {
      "viewBox": "0 0 80 80"
    }
  }, [_c('path', {
    attrs: {
      "stroke-dasharray": "160",
      "stroke-linecap": "round",
      "d": "M40 40l8.201-8.201c4.53-4.53 11.873-4.53 16.402 0A11.598 11.598 0 0 1 68 40c0 6.405-5.193 11.598-11.598\n             11.598a11.598 11.598 0 0 1-8.201-3.397L40 40l-8.201-8.201c-4.53-4.53-11.873-4.53-16.402 0A11.598 11.598 0 0\n             0 12 40c0 6.405 5.193 11.598 11.598 11.598 3.076 0 6.026-1.222 8.201-3.397L40 40z",
      "stroke-width": "7",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }